export default "__VITE_ASSET__81b67430__"